<template>
     <!-- Confirmation Modal -->
     <MdModal :id="`${modalId}-modal`"
     width="730px" :isopen="isModalOpen"
     enablebackdropclick="false"
     showoverlay="true"
     @handleclose="$emit('closeModal')" :data-qa-id="`${modalId}-modal`">
         <MdTypography slot="header" tag="h5" textalign="start" color="spirits--900" variant="heading5--medium"
             :data-qa-id="`${modalId}-modal-title`">
             {{modalHeader}}</MdTypography>
         <div slot="body">
             <MdTypography slot="body" tag="p" textalign="start" color="spirits--700" variant="body1--regular"
                 :id="`${modalId}-modal-description`">{{modalDescription}}</MdTypography>
         </div>
         <MdButton slot="footer" size="large" textalign="center" color="lightgrey"
             type="button" tabidx="2" @click="$emit('closeModal')" :data-qa-id="`${modalId}-modal-cancel`" variant="none">
             {{modalSecondaryButtonText}}</MdButton>
         <MdButton slot="footer" size="large" textalign="center" :color="primaryButtonColor"
             tabidx="2" @click="$emit('handleAction')" variant="none" :disabled="showLoaderInPrimaryButton"
             :data-qa-id="`${modalId}-modal-delete`">
             <MdSpinner v-if="showLoaderInPrimaryButton" slot="icon-start" :aria-label="modalId" size="16" showbox="false"
                 color="white"></MdSpinner>
             {{modalPrimaryButtonText}}
         </MdButton>
     </MdModal>
</template>